var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-text-field', _vm._b({
    attrs: {
      "flat": "",
      "dense": "",
      "solo": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_vm._t("default")];
      },
      proxy: true
    }, {
      key: "append",
      fn: function () {
        return [!_vm.readonly ? [_c('v-btn', {
          attrs: {
            "small": "",
            "icon": "",
            "text": ""
          },
          on: {
            "click": _vm.emit
          }
        }, [_c('v-icon', [_vm._v("mdi-content-save")])], 1)] : _vm._e(), _c('v-btn', {
          attrs: {
            "small": "",
            "icon": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.readonly = !_vm.readonly;
            }
          }
        }, [_vm.readonly ? [_c('v-icon', [_vm._v("mdi-pencil")])] : [_c('v-icon', [_vm._v("mdi-close")])]], 2)];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }, 'v-text-field', {
    readonly: _vm.readonly
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }